const C = {
  name: "CashRegister",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19 1H12V3H19V1Z" fill="currentColor"/>
<path d="M17.25 10C17.25 10.69 16.69 11.25 16 11.25C15.31 11.25 14.75 10.69 14.75 10C14.75 9.31 15.31 8.75 16 8.75C16.69 8.75 17.25 9.31 17.25 10Z" fill="currentColor"/>
<path d="M16 15.25C16.69 15.25 17.25 14.69 17.25 14C17.25 13.31 16.69 12.75 16 12.75C15.31 12.75 14.75 13.31 14.75 14C14.75 14.69 15.31 15.25 16 15.25Z" fill="currentColor"/>
<path d="M9.25 10C9.25 10.69 8.69 11.25 8 11.25C7.31 11.25 6.75 10.69 6.75 10C6.75 9.31 7.31 8.75 8 8.75C8.69 8.75 9.25 9.31 9.25 10Z" fill="currentColor"/>
<path d="M8 15.25C8.69 15.25 9.25 14.69 9.25 14C9.25 13.31 8.69 12.75 8 12.75C7.31 12.75 6.75 13.31 6.75 14C6.75 14.69 7.31 15.25 8 15.25Z" fill="currentColor"/>
<path d="M13.25 10C13.25 10.69 12.69 11.25 12 11.25C11.31 11.25 10.75 10.69 10.75 10C10.75 9.31 11.31 8.75 12 8.75C12.69 8.75 13.25 9.31 13.25 10Z" fill="currentColor"/>
<path d="M12 15.25C12.69 15.25 13.25 14.69 13.25 14C13.25 13.31 12.69 12.75 12 12.75C11.31 12.75 10.75 13.31 10.75 14C10.75 14.69 11.31 15.25 12 15.25Z" fill="currentColor"/>
<path d="M3 8V17H0V23H24V17H21V8C21 6.34772 19.6523 5 18 5H6C4.34772 5 3 6.34772 3 8ZM19 8V17H5V8C5 7.45228 5.45228 7 6 7H18C18.5477 7 19 7.45228 19 8ZM2 19H22V21H2V19Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as CashRegister
};
